import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const squadData = [
  {
    name: "Porter Gustin",
    role: "Founder/Owner, COO",
    tags: ["USC Graduate", "All Pac-12", "Team Captain", " 4 Year NFL vet"],
    image: "player1.jpg",
  },
  {
    name: "Harvey Langi",
    role: "Founder/Owner, CEO",
    tags: ["BYU Graduate", "Team Captain", "7 Year NFL Vet"],
    image: "player2.jpg",
  },
  {
    name: "Derek Wright",
    role: "Combine specialist",
    tags: ["Utah St Graduate", "3 Year NFL Vet"],
    image: "player3.jpg",
  },
  {
    name: "Chris Wilcox",
    role: "Combine specialist",
    tags: ["BYU Graduate", "4 year NFL vet"],
    image: "player4.jpg",
  },
  {
    name: "De'Ondre Wesley",
    role: "Combine specialist",
    tags: ["BYU Graduate", "5 Year NFL vet"],
    image: "player5.jpg",
  },
  {
    name: "Dax Milne",
    role: "Combine specialist",
    tags: ["BYU Graduate", "4 Year NFL Vet"],
    image: "player6.jpg",
  },
];

const SquadSection = () => {
  const [current, setCurrent] = useState(0);
  const [visibleCards, setVisibleCards] = useState(3);

  const updateVisibleCards = () => {
    if (window.innerWidth < 640) {
      setVisibleCards(1);
    } else {
      setVisibleCards(2);
    }
  };

  useEffect(() => {
    updateVisibleCards();
    window.addEventListener("resize", updateVisibleCards);
    return () => window.removeEventListener("resize", updateVisibleCards);
  }, []);

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? squadData.length - visibleCards : prev - 1,
    );
  };

  const nextSlide = () => {
    setCurrent((prev) =>
      prev + 1 >= squadData.length - visibleCards + 1 ? 0 : prev + 1,
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) =>
        prev + 1 >= squadData.length - visibleCards + 1 ? 0 : prev + 1,
      );
    }, 3000);
    return () => clearInterval(interval);
  }, [visibleCards]);

  return (
    <section className="squad-bg text-white py-24 px-4 md:px-8 pl-4 xl:pl-40">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center lg:items-start gap-8">
        {/* Left Section */}
        <div className="lg:w-1/2">
          <h2 className="text-white uppercase text-4xl md:text-5xl font-black italic mb-6 text-center lg:text-left">
            THE SQUAD
          </h2>
          <ul className="space-y-3 text-white text-xl text-center lg:text-left">
            <li>Access to elite athletes at the event</li>
            <li>
              Player management system to help scouting teams follow specific
              players or player types
            </li>
            <li>
              Find athletes using analytics and data that may have not been
              found otherwise
            </li>
          </ul>
        </div>

        {/* Right Section - Carousel */}
        <div className="lg:w-1/2 relative w-full">
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${current * (280 + 16)}px)` }}
            >
              {squadData.map((player, idx) => (
                <div
                  key={idx}
                  className="bg-white text-black rounded-xl shadow-lg overflow-hidden mx-2"
                  style={{ minWidth: "280px" }}
                >
                  <img
                    src={player.image}
                    alt={player.name}
                    className="w-full h-56 object-cover"
                  />
                  <div className="p-4">
                    <h3 className="font-bold text-lg">{player.name}</h3>
                    <p className="text-sm text-gray-600">{player.role}</p>
                    <div className="mt-2 flex flex-wrap gap-2">
                      {player.tags.map((tag, i) => (
                        <span
                          key={i}
                          className="bg-gray-100 text-gray-700 px-3 py-1 text-xs rounded-full"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow"
          >
            <FontAwesomeIcon icon={faChevronLeft} className="text-gray-600" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow"
          >
            <FontAwesomeIcon icon={faChevronRight} className="text-gray-600" />
          </button>

          {/* Dots */}
          <div className="flex justify-center mt-4 space-x-2">
            {Array.from({ length: squadData.length - visibleCards + 1 }).map(
              (_, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrent(idx)}
                  className={`w-3 h-3 rounded-full ${current === idx ? "bg-white" : "bg-gray-400"}`}
                ></button>
              ),
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SquadSection;
